// TODO: replace with the real number (digits only, country code, no +/spaces)
// and the real Facebook Page URL before going live.
const WHATSAPP_NUMBER = "+94770507575";
const FACEBOOK_URL = "https://www.facebook.com/VirooshSports";
const INSTAGRAM_URL = "https://www.instagram.com/viroosh_sports_complex/"

const FloatingCTAs = () => {
  return (
    <div className="fixed right-2 md:right-6 top-1/2 -translate-y-1/2 z-40 flex flex-col gap-3">
      <a
        href={`https://wa.me/${WHATSAPP_NUMBER}`}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Chat on WhatsApp"
        className="w-12 h-12 flex items-center justify-center rounded-full bg-black/70 hover:bg-red-700 border border-white/10 shadow-lg shadow-black/30 transition-colors duration-200"
      >
        <svg viewBox="0 0 24 24" className="w-6 h-6 fill-white">
          <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.372-.025-.521-.075-.15-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.872.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z" />
          <path d="M12.001 2C6.478 2 2 6.477 2 12c0 1.99.583 3.842 1.588 5.4L2 22l4.735-1.559A9.953 9.953 0 0 0 12.001 22C17.523 22 22 17.523 22 12S17.523 2 12.001 2zm0 18.14a8.11 8.11 0 0 1-4.13-1.132l-.296-.176-2.812.927.938-2.741-.193-.282A8.111 8.111 0 0 1 3.86 12c0-4.487 3.653-8.14 8.14-8.14 4.486 0 8.14 3.653 8.14 8.14 0 4.487-3.654 8.14-8.14 8.14z" />
        </svg>
      </a>

      <a
        href={FACEBOOK_URL}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Visit our Facebook page"
        className="w-12 h-12 flex items-center justify-center rounded-full bg-black/70 hover:bg-red-700 border border-white/10 shadow-lg shadow-black/30 transition-colors duration-200"
      >
        <svg viewBox="0 0 24 24" className="w-6 h-6 fill-white">
          <path d="M22 12.06C22 6.505 17.523 2 12 2S2 6.505 2 12.06c0 5.02 3.657 9.184 8.438 9.94v-7.03H7.898v-2.91h2.54V9.845c0-2.522 1.492-3.915 3.777-3.915 1.094 0 2.238.196 2.238.196v2.476h-1.26c-1.243 0-1.63.775-1.63 1.57v1.888h2.773l-.443 2.91h-2.33V22c4.78-.756 8.437-4.92 8.437-9.94z" />
        </svg>
      </a>
      <a
        href={INSTAGRAM_URL}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Visit our Instagram page"
        className="w-12 h-12 flex items-center justify-center rounded-full bg-black/70 hover:bg-red-700 border border-white/10 shadow-lg shadow-black/30 transition-colors duration-200"
      >
        <svg viewBox="0 0 24 24" className="w-6 h-6 fill-white">
          <path d="M7.75 2C4.574 2 2 4.574 2 7.75v8.5C2 19.426 4.574 22 7.75 22h8.5C19.426 22 22 19.426 22 16.25v-8.5C22 4.574 19.426 2 16.25 2h-8.5zm0 2h8.5A3.75 3.75 0 0 1 20 7.75v8.5A3.75 3.75 0 0 1 16.25 20h-8.5A3.75 3.75 0 0 1 4 16.25v-8.5A3.75 3.75 0 0 1 7.75 4zm8.75 1a1.25 1.25 0 1 0 0 2.5A1.25 1.25 0 0 0 16.5 5zM12 7a5 5 0 1 0 0 10 5 5 0 0 0 0-10zm0 2a3 3 0 1 1 0 6 3 3 0 0 1 0-6z" />
        </svg>
      </a>
    </div>
  );
};

export default FloatingCTAs;
